import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { serverUrl } from '../../constants'

// Define a service using a base URL and expected endpoints
export const staffUserApi = createApi({
  reducerPath: 'staffUsers',
  baseQuery: fetchBaseQuery({
    baseUrl: serverUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.value
      // console.log('token state', token)
      // If we have a token set in state, let's assume that we should be passing it.
      headers.set('authorization', `Bearer ${token}`)
      headers.set('Content-Type', `application/json`)
      if (token) {
        // window.localStorage.setItem('token', token)
      }
      return headers
    }
  }),
  tagTypes: ['StaffUsers'],
  endpoints: (builder) => ({
    fetchStaffUsers: builder.query({
      query: (mId) => ({
        url: `staffUsers?mId=${mId}`,
      }),
      providesTags: ['StaffUsers'],
    }),
    addStaffUser: builder.mutation({
      query: ({ mId, ...rest }) => ({
        url: `staffUsers?mId=${mId}`,
        method: 'POST',
        body: rest
      }),
      invalidatesTags: ['StaffUsers'],
    }),
    updateStaffUser: builder.mutation({
      query: ({ mId, id, ...rest }) => ({
        url: `staffUsers/${id}?mId=${mId}`,
        method: 'POST',
        body: rest
      }),
      invalidatesTags: ['StaffUsers'],
    }),
    deleteStaffUser: builder.mutation({
      query: ({ mId, id }) => ({
        url: `staffUsers/${id}?mId=${mId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['StaffUsers'],
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useFetchStaffUsersQuery, useAddStaffUserMutation, useUpdateStaffUserMutation, useDeleteStaffUserMutation, } = staffUserApi